import { agent } from './agent';
import {reset} from '../store/auth.duck';
import {AuthType, GetCurrentAuthType, persistAuthType, resetAllLoginStorages} from '@shared/utils/AuthUtils';
import { msalInstance } from './msalInstance';

const login =  async (data) => {
  try {
    const resp = await agent.requests.post('/login', data, true);
    localStorage.setItem('idToken', resp.token);
    persistAuthType(AuthType.Standard);
    return resp;
  } catch (err) {
    throw err;
  }
};

const loginWithInvitation =  async (data) => {
  try {
    const resp = await agent.requests.post('/loginWithInvite', data, true);
    localStorage.setItem('idToken', resp.token);
    persistAuthType(AuthType.Standard);
    return resp;
  } catch (err) {
    throw err;
  }
};

const azureAcceptInvite =  async () => {
  try {
    const resp = await agent.requests.post('/loginWithAzureInvite', {}, true);
    return resp;
  } catch (err) {
    throw err;
  }
};

const googleAcceptInvite =  async () => {
  try {
    const resp = await agent.requests.post('/loginWithGoogleInvite', {}, true);
    return resp;
  } catch (err) {
    throw err;
  }
};

const register = (data) => agent.requests.post('/register', data);

const forgotPassword = (email) => agent.requests.post('/api/forgot-password/request', {email});

const resetPassword = (password, resetId) => agent.requests.post('/api/forgot-password/reset', {password, resetId}, true);

function loginWithAzureRequest(refreshToken) {
  return agent.requests.post('/login/azure', {
    refreshToken: refreshToken,
  }, false);
}

const current = async (passive = false) => {
  const resp = await agent.requests.get('/current', passive);
  return resp;
};

export const rawUserRequest = async () => {
  return await agent.requests.get('/current', true, true);
};

const authenticate = () => {
  const idToken = localStorage.getItem('idToken');
  const data = {
    type: 'google',
    data: {
      idToken
    },
  }
  return agent.requests.post('/authenticate', data);
}

const disableSlackSync = () => agent.requests.put('/api/integration/slack/disable');

const logout = (dispatch) => {
  const authType = GetCurrentAuthType();
  resetAllLoginStorages();
  dispatch(reset());
  if (authType === AuthType.Microsoft) {
    msalInstance.logoutRedirect({ postLogoutRedirectUri: '/' });
  } else {
    window.location.href = '/';
  }
};

const validateEmail = (id) => {
  return agent.requests.post('/register/validate', {id});
}

export function requestValidationEmail(email) {
  return agent.requests.post('/register/resend-verification', {email})
}

export const Auth = {
  register,
  login,
  loginWithInvitation,
  current,
  authenticate,
  logout,
  forgotPassword,
  resetPassword,
  disableSlackSync,
  validateEmail,
  azureAcceptInvite,
  googleAcceptInvite,
}
